module.exports = __webpack_public_path__ + "static/media/green_right_tick.4eb76251.svg";